import { FC } from 'react';
import { PageTitle, PageLink } from '../../../rbts/layout/core';
import { View } from './components/View';

const CodigosPromocionalesPage: FC = () => {
  const widgetsBreadCrumbs: Array<PageLink> = [];

  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>Códigos promocionales</PageTitle>
      <View />
    </>
  );
};

export { CodigosPromocionalesPage };
